module.exports = {
  businessIntelligenceChartTab: 'BI图表',
  businessIntelligenceDashboardTab: 'BI仪表盘',
  chartGroupSettingTab: '图表分组设置',
  chartConfigurationManagement: '租户BI图表管理',
  common: {
    query: '查询',
    edit: '编辑',
    save: '保存',
    cancel: '取消',
    tenantName: '租户名称',
    saveSuccess: '保存成功'
  },
  businessIntelligence: {
    searchKeyword: '请输入关键字搜索',
    copyChart: '复制图表和仪表盘',
    copyAll: '复制到所有租户',
    all: '全部',
    copyIdRemind: '请输入复制对象ID',
    copyAllRemind: '请选择需要复制到的租户',
    chartIdPlaceholder: '请输入ID',
    chart: '图表',
    dashboard: '仪表盘',
    type: '类型',
    copyTo: '复制到部分租户',
    copyChartId: '复制对象ID',
    openBiChart: '开通BI图表',
    openTenantBiChart: '开通租户BI图表',
    selectTenant: '租户选择',
    keywords: '请输入关键词',
    note: '备注',
    chartNumber: '编辑租户图表数量',
    tenantId: '租户ID',
    initializeChartNum: '可用图表数',
    hasBeenUsedChart: '已用图表数',
    openingDate: '开通日期',
    adjustNumber: '调整数量',
    expirationTime: '过期时间',
    selectTime: '选择时间',
    adjust1: '增加',
    adjust2: '减少',
    available: '租户图表可用数量',
    hasBeenUsed: '租户图表已用数量',
    noteInformation: '备注信息',
    saveWarning: '请选择租户',
    saveSuccess: '开通成功',
    copySuccess: '复制成功',
    editWarning: '请完善调整数量',
    editWarningTime: '请填写过期时间',
    editSuccess: '保存成功',
    adjustQuantity1: '调整数量不可输入负数',
    adjustQuantity2: '调整减少数量不可大于用户图表数'
  },
  businessIntelligenceChart: {
    myChartNum: '我的图表数',
    addChart: '添加定制图表',
    queryChart: '查询我的图表',
    standardChart: 'BI标准图表模板库(请选择需要的图表)',
    queryStandardChart: '查询图表模板',
    chartTemplate: '图表模板：',
    classification: '分类：',
    chartName: '图表名称',
    chartGrouping: '图表分组',
    chartId: '图表ID值',
    remark: '备注说明',
    editChart: '编辑用户图表',
    selectAll: '全部',
    hasChosen: '已选择',
    notChoose: '未选择',
    chartNamePrompt: '请输入图表名称',
    chartIdPrompt: '请输入图表ID值',
    addSuccess: '添加成功',
    deleteSuccess: '删除成功',
    warmPrompt: '温馨提示',
    warmPromptStatements: '尊敬的租户，您的图表使用数量（${0}张）已达上限，如果需增加图表可使用数量，可联系WallTech在线客服或运行021-65143931咨询了解。',
    confirmButtonText: '知道了'
  },
  chartGroupSetting: {
    viewChart: '查看图表',
    newGrouping: '新建分组',
    delete: '删除',
    order: '顺序号',
    groupName: '分组名称',
    groupNameTips: '分组名称不可重复',
    remark: '备注',
    selectGrouping: '选择图表加入分组',
    queryChartName: '图表名称查询',
    eidtChart: '编辑图表',
    currentGrouping: '当前分组',
    chartDescription: '图表说明',
    addGroup: '新增分组',
    editGroup: '编辑分组',
    rankRemind: '请填写分组顺序号',
    groupingNameRemind: '请填写分组名称',
    chartNameRemind: '请填写图表名称',
    chartGrouping: '请选择图表分组',
    deleteSuccess: '删除成功'
  },
  businessIntelligenceDashboard: {
    addDashboard: '添加仪表盘',
    delete: '删除',
    fullScreen: '全屏展示',
    setFilter: '设置筛选项',
    preview: '预览',
    saveLayout: '保存布局',
    dragTips: '您可通过拖拽来调整图表位置和大小。',
    addChart: '添加图表',
    dashboardType: '仪表盘类型',
    customizeDashboard: '自定义仪表盘',
    biDashboard: 'BI仪表盘',
    dashboardName: '仪表盘名称',
    dashboardId: '仪表盘ID值',
    dashboardNamePlaceholder: '请输入仪表盘名称',
    classification: '仪表盘分类',
    biDashboardId: 'BI仪表盘ID值',
    biDashboardIdPlaceholder: '请输入仪表盘ID值',
    Notes: '说明备注',
    setAccessRights: '设置访问权限',
    selectBranch: '选择分公司',
    selectBranchPlaceholder: '请选择公司',
    selectDepartment: '选择部门',
    selectDepartmentPlaceholder: '请选择部门',
    selectPersonnel: '选择人员',
    selectPersonnelPlaceholder: '请选择人员',
    setDataPermission: '设置数据权限',
    whole: '查看全部数据',
    company: '查看分公司数据',
    department: '查看部门数据',
    personal: '仅查看个人数据',
    rolePermissions: '根据角色权限查看数据',
    chartAddDashboard: '选择图表加入仪表盘',
    queryChartName: '图表名称查询',
    add: '添加',
    seePreview: '*请点击预览查看效果',
    determine: '确定',
    setQueryItem: '设置仪表盘查询项',
    grouping: '分组',
    businessDashboard: '业务仪表盘',
    financialDashboard: '财务仪表盘',
    deleteConfirm: '是否删除该仪表盘？',
    tips: '提示',
    saveTips: '请选择图表加入仪表盘',
    saveTips1: '仪表盘名称不可重复',
    prompt1: '设置仪表盘可访问权限，如：上海分公司 操作部 张三。',
    prompt2: '如只设置分公司，即公司名下所有人员都可访问。',
    prompt3: '数据权限可限制当前用户的数据可见范围。',
    prompt4: '如：仅个人，表示只见自己的业务数据。',
    prompt5: '可通过WallTech在线客服或运营021-65143931了解更多!',
    prompt6: '尊敬的租户，如果需要了解和使用更多的BI应用，可联系WallTech在线客服或致电021-65143931咨询了解。'
  }
}
// $t('BusinessIntelligence.common')
